import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import AppLayout from '../layouts/AppLayout.vue';

import AuthLayout from '../layouts/AuthLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'roles' },
  },
  {
    name: 'base',
    path: '/',
    component: AppLayout,
    redirect: { name: 'users' },
    children: [
      {
        name: 'settings',
        path: 'settings',
        component: () => import('@/pages/settings/Settings.vue'),
      },
      {
        name: 'profile',
        path: 'profile',
        component: () => import('@/pages/profile/Profile.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('@/pages/users/UsersPage.vue'),
      },
      {
        name: 'roles',
        path: 'roles',
        component: () => import('@/pages/roles/RolesPage.vue'),
      },
      {
        name: 'players',
        path: 'players',
        component: () => import('@/pages/players/PlayersPage.vue'),
      },
      {
        name: 'player-battles',
        path: 'players/:id/battles',
        component: () => import('@/pages/players/PlayerBattlesPage.vue'),
      },
      {
        name: 'player-transactions',
        path: 'players/:id/transactions',
        component: () => import('@/pages/players/PlayerTransactionsPage.vue'),
      },
      {
        name: 'promocodes',
        path: 'promocodes',
        component: () => import('@/pages/promocodes/PromocodesPage.vue'),
      },
      {
        name: 'complaints',
        path: 'complaints',
        component: () => import('@/pages/complaints/ComplaintsPage.vue'),
      },
      {
        name: 'notifications',
        path: 'notifications',
        component: () => import('@/pages/notifications/NotificationsPage.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: '',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

export default router;
